import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=a42fffba&scoped=true&"
import script from "./courseDetail.vue?vue&type=script&lang=js&"
export * from "./courseDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=a42fffba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42fffba",
  null
  
)

export default component.exports